/**
 * @generated SignedSource<<eae09051a55aa54ce7e9db0a351c577a>>
 * @relayHash 0dc51d4e6b21d806122d9dcffa795bcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ad25d5510f09dfa2653e56b9d7b9d15e81bd26b00f4b66aa0374e8710435b010

import type { ConcreteRequest } from 'relay-runtime';
export type BulkRoleAssignmentSpaceType = "COLLABORATION" | "GLOBAL" | "KNOWLEDGE_BASE" | "PERSONAL" | "%future added value";
export type RoleAssignmentPrincipalType = "ACCESS_CLASS" | "APP" | "GROUP" | "USER" | "%future added value";
export type useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation$variables = {
  principalId: string;
  principalType: RoleAssignmentPrincipalType;
  spaceTypes: ReadonlyArray<BulkRoleAssignmentSpaceType | null | undefined>;
};
export type useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation$data = {
  readonly bulkRemoveRoleAssignmentFromSpaces: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
    readonly taskId: string | null | undefined;
  } | null | undefined;
};
export type useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation = {
  response: useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation$data;
  variables: useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "principalId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "principalType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceTypes"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "principalId",
                "variableName": "principalId"
              },
              {
                "kind": "Variable",
                "name": "principalType",
                "variableName": "principalType"
              }
            ],
            "kind": "ObjectValue",
            "name": "principal"
          },
          {
            "kind": "Variable",
            "name": "spaceTypes",
            "variableName": "spaceTypes"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "BulkRemoveRoleAssignmentFromSpacesPayload",
    "kind": "LinkedField",
    "name": "bulkRemoveRoleAssignmentFromSpaces",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "taskId"
      },
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0dc51d4e6b21d806122d9dcffa795bcf",
    "id": "ad25d5510f09dfa2653e56b9d7b9d15e81bd26b00f4b66aa0374e8710435b010",
    "metadata": {},
    "name": "useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation",
    "operationKind": "mutation",
    "text": "mutation useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation($principalId:ID!,$principalType:RoleAssignmentPrincipalType!,$spaceTypes:[BulkRoleAssignmentSpaceType]!){bulkRemoveRoleAssignmentFromSpaces(input:{principal:{principalId:$principalId,principalType:$principalType},spaceTypes:$spaceTypes}){taskId,success,errors{message}}}"
  }
};
})();

(node as any).hash = "a5efdd94809c62d366be293748749bcb";

export default node;
